var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessageCircle = function SvgMessageCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: "M84 46a33.5 33.5 0 0 1-3.6 15.2A34 34 0 0 1 50 80a33.5 33.5 0 0 1-15.2-3.6L12 84l7.6-22.8A33.5 33.5 0 0 1 16 46a34 34 0 0 1 18.8-30.4A33.5 33.5 0 0 1 50 12h2a33.92 33.92 0 0 1 32 32z"
  })));
};
export default SvgMessageCircle;